import React, { Component } from 'react';
import { Button, Form, Input, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import { DateTimePicker } from 'react-widgets';

class StudentRole extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            roleName: 'student',
            roles: [1, 2]
        };
        this.getStudentRoles = this.getStudentRoles.bind(this);
        this.archiveRole = this.archiveRole.bind(this);
        this.addRole = this.addRole.bind(this);
    }
    componentDidMount() {
        this.getStudentRoles();
    }

    archiveRole(id) {
        let obj = { id };
        axios.put('user/archive-user-role', { ...obj })
            .then(res => {
                this.getStudentRoles();
                toast('Uloga je uspješno arhivirana.');
            })
            .catch(err => {
                toast('Došlo je do greške. Uloga nije arhivirana.');
                console.log('Failed to archive user role.');
            });
    }

    addRole() {
        const { studentStudyProgramId } = this.props;
        axios.post(`user/add-student-role/${studentStudyProgramId}`)
            .then(res => {
                this.setState({ newRole: false });
                this.getStudentRoles();
                toast('Uspješno ste dodali ulogu.');
            })
            .catch(err => {
                if (err.response.data === 'User needs to be created first before adding a role.') {
                    toast('Student nema kreirane pristupne podatke.');
                } else {
                    toast('Došlo je do greške. Uloga nije kreirana.');
                }
            });
    }

    activeRole(id) {
        let obj = { id };
        axios.put('user/unarchive-user-role', { ...obj })
            .then(res => {
                this.getStudentRoles();
                toast('Uloga je uspješno aktivirana.');
            })
            .catch(err => {
                toast('Došlo je do greške. Uloga nije aktivirana.');
                console.log('Failed to archive user role.');
            });
    }

    getStudentRoles() {
        const { studentStudyProgramId } = this.props;
        this.setState({ loader: true });
        axios.get(`user/get-user-roles-for-ssp/${studentStudyProgramId}`)
            .then(res => {
                this.setState({ roles: res.data ? res.data : [], loader: false, disableAddButton: res.data.length !== 0 });
            })
            .catch(err => {
                console.log('Failed to fetch user roles.');
            });
    }

    handleChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    render() {
        let {
            roles, loader, disableAddButton, newRole
        } = this.state;
        return (
            loader ?
                <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                :
                <Table celled selectable compact size="small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                                Naziv uloge
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Status uloge
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Datum kreiranja
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Datum arhiviranja
                            </Table.HeaderCell>
                            <Table.HeaderCell verticalAlign="middle" textAlign="center" >
                                <Popup
                                    content="Dodaj ulogu"
                                    position="top center"
                                    trigger={
                                        <Button
                                            disabled={disableAddButton}
                                            icon="add"
                                            size="small"
                                            basic="true"
                                            color="blue"
                                            circular
                                            onClick={() => this.setState({ newRole: true })}
                                        />}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.newRole && <Table.Row>
                            <Table.Cell verticalAlign="middle">
                                Student
                                {/* <Form noValidate> */}
                                {/*    <Form.Field */}
                                {/*        required */}
                                {/*        disabled */}
                                {/*        control={Input} */}
                                {/*        placeholder="Unesite naziv uloge" */}
                                {/*        value={this.state.roleName} */}
                                {/*        name="roleName" */}
                                {/*        onChange={this.handleInputChange} */}
                                {/*    /> */}
                                {/* </Form> */}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {/* <Form noValidate> */}
                                {/*    <Form.Field */}
                                {/*        required */}
                                {/*        disabled */}
                                {/*        control={Input} */}
                                {/*        placeholder="Unesite tip uloge" */}
                                {/*        value={this.state.roleType} */}
                                {/*        name="roleType" */}
                                {/*        onChange={this.handleInputChange} */}
                                {/*    /> */}
                                {/* </Form> */}
                                aktivna
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                <Form noValidate>
                                    <Form.Field required error={this.state.dateErr} disabled={!this.state.examTerm}>
                                        <DateTimePicker
                                            defaultValue={new Date()}
                                            format="D. M. YYYY. - HH:mm"
                                            timeFormat="HH:mm"
                                            onChange={this.handleChange.bind(null, 'date')}
                                            value={this.state.date}
                                            placeholder="Unesite datum u formatu D. M. GGGG."
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" />
                            <Table.Cell verticalAlign="middle" textAlign="center">
                                <Popup
                                    content="Potvrdi"
                                    position="top center"
                                    trigger={
                                        <Button
                                            basic="true"
                                            circular
                                            size="small"
                                            color="green"
                                            icon="check"
                                            onClick={() => this.addRole()}
                                        />}
                                />
                                <Popup
                                    content="Odustani"
                                    position="top center"
                                    trigger={
                                        <Button
                                            basic="true"
                                            circular
                                            size="small"
                                            color="red"
                                            icon="close"
                                            onClick={() => this.setState({ newRole: false })}
                                        />}
                                />

                            </Table.Cell>
                        </Table.Row>}
                        {roles.length ? roles.map((el, index) =>
                            (<Table.Row key={el.userRoleId}>
                                <Table.Cell verticalAlign="middle">
                                    {el.userTypeName}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.archived ? 'arhivirana' : 'aktivna'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.createdOn ? moment(el.createdOn).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.dateOfArchiving ? moment(el.dateOfArchiving).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Popup
                                        content="Arhiviraj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={el.archived}
                                                basic="true"
                                                circular
                                                size="small"
                                                color="red"
                                                icon="sign-out"
                                                onClick={() => this.archiveRole(el.userRoleId)}
                                            />}
                                    />
                                    <Popup
                                        content="Aktiviraj"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={roles.filter(e => !e.archived).length !== 0 || !el.archived}
                                                basic="true"
                                                circular
                                                size="small"
                                                color="green"
                                                icon="sign-out"
                                                onClick={() => this.activeRole(el.userRoleId)}
                                            />}
                                    />
                                </Table.Cell>
                            </Table.Row>
                            )) : !newRole ? <h6><br />Nema podataka.</h6> : null
                        }

                    </Table.Body>

                </Table>


        );
    }
}

export default StudentRole;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentRole.js